import { render, staticRenderFns } from "./confirmDeleteModal.vue?vue&type=template&id=237dc54a&scoped=true"
import script from "./confirmDeleteModal.vue?vue&type=script&lang=js"
export * from "./confirmDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./confirmDeleteModal.vue?vue&type=style&index=0&id=237dc54a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237dc54a",
  null
  
)

export default component.exports